<template>
    <div id="topics">
        <div class="panel-topics">
            <h2 class="page-header">Waarmee wil je aan de slag?</h2>
                <label class="label-header">Kies maximaal 3 focuspunten:</label>
                <div class="two-column checkboxes-container">
                    <div class="checkbox-group-wrapper" v-for="( topics, group, index ) in orderedTopics">
                        <h6 v-show="group != null" class="topics-group-title" :class="{ 'first': index === 0 }">{{ group }}</h6>
                        <div class="checkbox-wrapper" v-for="( topic ) in topics" :key="topic.id">
                            <label>
                                <input type="checkbox" :value="topic.id" :key="topic.id" v-model="answer.topics"><span class="tick">{{ topic | alternative_title }}</span>
                            </label>
                        </div>
                    </div>
                </div>
                <div class="alert-container" v-if="!isValid('topics')">
                    <div class="alert alert-danger" v-if="invalid.topics.min">Maak minimaal {{ invalid.topics.min }} keuze</div>
                    <div class="alert alert-danger" v-if="invalid.topics.max">Je mag maximaal {{ invalid.topics.max }} opties selecteren</div>
                </div>
                <div class="buttons-container">
                    <previous-button />
                    <next-button :isValid="isAnswered.topics && isValid('topics')" />
                </div>
        </div>
    </div>
</template>

<script>
    import NextButton from "../partials/NextButton";
    import PreviousButton from "../partials/PreviousButton";

    export default {
        name: 'Topics',
        components: {
            PreviousButton,
            NextButton
        },
        props: {
            isValid: {
                type: Function
            },
            answer: {
                type: Object
            },
            invalid: {
                type: Object
            },
            isAnswered: {
                type: Object
            }
        },
        computed: {
            allTopics: function() {
                return this.allFeatures.filter(function (feature) {
                    return feature.cluster === 'topic'
                })
            },
            topicsByTitle: function() {
                return this.allTopics.reduce(function(rv, x) {
                  (rv[x['group']] = rv[x['group']] || []).push(x);
                  return rv;
                }, {});
            },
            orderedTopics: function() {
                var titleOrder = [
                  'Persoonlijke ontwikkeling',
                  'Stress',
                  'Werk en financiën',
                  'Gezondheid',
                  'Relaties'
                ];

                return Object.fromEntries(
                    Object.entries(this.topicsByTitle).sort(function(a, b) {
                    return titleOrder.indexOf(a[0])
                        - titleOrder.indexOf(b[0]);
                }));
            }
        },
        filters: {
          alternative_title: f => f.title_alternative ? f.title_alternative : f.title,
        },
        data() {
            return {
                allFeatures: allFeatures,
                rules: {
                    topics: {
                        min: 1,
                        max: 3
                    }
                }
            }
        },
        created() {
            this.$emit('setRules', this.rules)
        }
    }

</script>
